import { companyInfo } from '../data/mock';
import TrustBadges from './Hero/TrustBadges';
import HeroCTA from './Hero/HeroCTA';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="hero-section">
      <div className="hero-background">
        <img
          src={companyInfo.heroImage}
          alt="Quartier Bois-Franc - Lavage de Vitre résidentiel"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="hero-badge">✨ Service Professionnel Bois-Franc</div>
        <h1 className="hero-title">Fenêtres Impeccables en 24h</h1>
        <p className="hero-subtitle-main">Résultats Spectaculaires - Satisfaction 100% Garantie</p>
        <TrustBadges />
        <HeroCTA bookingUrl={process.env.REACT_APP_BOOKING_URL} onLearnMore={scrollToContact} />
      </div>
    </section>
  );
};

export default Hero;